import { t } from 'ember-intl';
import { BreadcrumbsItem } from 'core/components';

import Members from 'hcp/components/page/groups/project/detail/members';

<template>
  <BreadcrumbsItem
    @route="cloud.access-control.groups.detail.members"
    @text={{t
      "components.page.access-control.groups.detail.members.breadcrumb"
      displayName=@model.group.displayName
      htmlSafe=true
    }}
  />

  {{#if @model.isProjectContext}}
    <Members
      @group={{@model.group}}
      @isProjectContext={{@model.isProjectContext}}
      @members={{@model.members}}
      @project={{@model.project}}
      @scimEnabled={{@model.scimEnabled}}
    />
  {{/if}}
</template>
